import http from '@/utils/http';
const base_path = '/v2/plan';

/**
 * 智能创建计划接口
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const createPlanApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 获取预览计划接口
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const getPreviewPlanApi = (data) => {
  return http.post({
    url: `${base_path}/preview`,
    data,
  });
};
